export const CANCEL_CLONED_SCHEDULE = 'CANCEL_CLONED_SCHEDULE';
export const CANCEL_CLONED_SCHEDULE_SUCCESS = 'CANCEL_CLONED_SCHEDULE_SUCCESS';
export const CANCEL_CLONED_SCHEDULE_ERROR = 'CANCEL_CLONED_SCHEDULE_ERROR';
